import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField } from "@mui/material";
import { MuiXHelpers_createElement } from "../../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getLocale } from "../../Locale.js";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";

export function description(locale, text, onChange) {
    return MuiHelpers_createElement(TextField, [["variant", "outlined"], ["fullWidth", true], ["label", locale.t("Desc")], ["multiline", true], ["minRows", 3], ["value", text], ["onChange", (e) => {
        onChange(e.target.value);
    }]]);
}

export function readOnlyPlannedDatePicker(lang, locale, plannedDateOpt) {
    let value_4, elems;
    return MuiXHelpers_createElement(LocalizationProvider, [["adapterLocale", getLocale(lang)], ["localeText", locale], (value_4 = AdapterDateFns, ["dateAdapter", value_4]), (elems = [MuiXHelpers_createElement(DateCalendar, [["autoFocus", false], ["readOnly", true], ["disablePast", false], ["value", plannedDateOpt]])], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

